import { useQuery } from '@tanstack/react-query'
import { PostEntityType, getPosts } from '../../api/posts'
import PostEditor from './PostEditor'
import PostItem from './PostItem'

interface Props {
  entityType: PostEntityType
  entityId: number
  canEdit: boolean
}

export default function PostsSection({ entityType, entityId, canEdit }: Props) {
  const {
    data: posts = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['posts', entityType, entityId],
    queryFn: () => getPosts(entityType, entityId),
    enabled: !!entityId,
  })

  return (
    <div className="bg-white rounded-lg shadow-md p-6 space-y-4">
      <h2 className="text-xl font-semibold text-gray-900">Посты и вложения</h2>

      {canEdit && (
        <PostEditor
          entityType={entityType}
          entityId={entityId}
          onPublished={() => {
            refetch()
          }}
        />
      )}

      {isLoading ? (
        <div className="text-gray-500">Загрузка постов...</div>
      ) : posts.length === 0 ? (
        <div className="text-gray-500">Пока постов нет. Самое время написать первый.</div>
      ) : (
        <div className="space-y-3">
          {posts.map((post) => (
            <PostItem key={post.id} post={post} canEdit={canEdit} onUpdated={refetch} />
          ))}
        </div>
      )}
    </div>
  )
}
